module.exports = __webpack_public_path__ + "img/Momentum_Aria_Floodlight.58a69ed8.png";